<template>
    <div class="modal-wrap" :class="dialog.state.active ? 'block' : 'hidden'">
        <div class="modal !w-fit !h-fit min-w-[320px] flex flex-col items-center p-24 rounded-16 shadow-shadow" @click.stop="">
            <div class="w-full flex justify-end">
                <div v-if="false" class="p-8 cursor-pointer" @click="dialog.cancel()">
                    <icon-cancel2 class="w-[28px] h-[28px]" fill="black" />
                </div>
            </div>
            <div class="flex flex-col items-center gap-32 w-full">
                <div class="flex flex-col" :class="dialog.state.message2 ? 'gap-12' : ''">
                    <p class="text-16 text-gray4 text-center font-semibold">
                        {{ dialog.state.message }}
                    </p>
                    <p class="text-14 text-gray3 text-center whitespace-pre-wrap">
                        {{ dialog.state.message2 }}
                    </p>
                </div>
                <div class="w-full flex gap-8">
                    <div
                        v-if="dialog.state.type === 'confirm'"
                        class="button big sub2 flex-1" @click="dialog.cancel()"
                    >{{ dialog.state.cancelText ? dialog.state.cancelText : '취소' }}</div>
                    <div
                        class="button big flex-1" @click="dialog.ok(true)"
                        :class="dialog.state.type === 'confirm' ? 'sub' : 'sub2'"
                    >{{ dialog.state.okText ? dialog.state.okText : '확인' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const dialog: any = inject("dialog");
</script>
